<template>
	<v-menu bottom left>
 		<template v-slot:activator="{ on }">
			<v-btn dark icon v-on="on">{{ lang }}</v-btn>
		</template>

		<v-list>
			<v-list-tile v-for="l in langs" :key="l.code" :disabled="l.code === lang" @click="onChangeLang(l.code)">
				<v-list-tile-title><span class="mr-2">{{ l.flag }}</span>{{ l.text }}</v-list-tile-title>
			</v-list-tile>
		</v-list>
	</v-menu>
</template>


<script>
import { langs, loadLanguage } from '@/plugins/i18n';

export default {
	name: 'lang-picker',
	data() { return {
		langs,
	}},
	computed: {
		lang() { return this.$i18n.locale },
	},
	methods: {
		onChangeLang(newLang) {
			loadLanguage(newLang);
		}
	}
}
</script>
